import { useParams, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import EthiccraftAbout from "./Ethiccraft_College_header";
import TestimonialSlider from "./Faculty_Testimonials";
import RecentEvents from "./Recent_Activities";
import '../Css/Colleges_Ethiccraft.css';
import Navbar from "../Navbar";

function EthiccraftCollege() {
  const { collegeCode } = useParams();
  const code = collegeCode.toLowerCase();

  const allowedColleges = [
    "main",
    "hrc",   // Hansraj College
    "rjc",   // Ramjas College
    "jcbust",// JC Bose UST
    "clc",   // Campus Law Center
    "nitp",  // NIT Patna
    "cu",    // Chandigarh University
    "pu",    // Punjab University
    "lpu",   // Lovely Professional University
    "fot",   // Faculty of Technology
    "cic",   // Cluster Innovation Center
    "mhc",   // Miranda House College
    "drc",   // Daulat Ram College
    "kmc",   // Kirori Mal College
    "arbc",  // Aryabhatt College
    "lbc",   // Laxmibai College
    "knc",   // Kamla Nehru College
    "kmv",   // Keshav Mahavidyalaya
    "srcc"   // Shri Ram College of Commerce
  ]; 
  //Whenever add a new college here, also add in Profile Edit & Profile Card

  if (!allowedColleges.includes(code)) {
    return <Navigate to="/" replace />;
  }

  const collegeName = code.toUpperCase();

  return (
    <AnimatePresence>
      <Navbar />
      <EthiccraftAbout collegeName={collegeName} />
      <TestimonialSlider collegeName={collegeName} />
      <RecentEvents collegeName={collegeName} />
    </AnimatePresence>
  );
}

export default EthiccraftCollege;